import React from 'react';
import { ProductDetailRows } from './ProductDetailRows';
import { ServiceAgreementV2, ServiceModel } from 'pco-product-service-internal-consumer';
import { formatDate } from '../../../../utils/dateUtils';
import { isActiveReferralServiceDefinitionId } from '../../privateBankingServiceDefinitionIds';
import { useTranslation } from 'react-i18next';

type ProductDetailsBlockProps = { serviceModel: ServiceModel; product: ServiceAgreementV2 };

export const ProductDetailsBlock: React.FC<ProductDetailsBlockProps> = ({ product, serviceModel }) => {
  const { t } = useTranslation();

  const activationDateLabel = isActiveReferralServiceDefinitionId(product.serviceDefinitionId)
    ? t('pb.productdetails.activeReferralWp.activationDate')
    : t('pb.productdetails.details.activeSince.label');
  const detailItems = [
    {
      label: t('pb.productdetails.details.createdBy.label'),
      value: product.createdBy ?? '-',
      testId: 'product-detail-created-by',
    },
    { label: activationDateLabel, value: formatDate(product.activeSince), testId: 'product-detail-active-since' },
    {
      label: t('pb.productdetails.details.closureDate.label'),
      value: formatDate(product.closureDate),
      testId: 'product-detail-closure-date',
    },
    {
      label: t('pb.productdetails.details.engagementType.label'),
      value: serviceModel?.engagementTypeName ?? '-',
      testId: 'product-detail-engagement-type',
    },
    {
      label: t('pb.productdetails.details.serviceModel.label'),
      value: serviceModel?.serviceModelName ?? '-',
      testId: 'product-detail-service-model',
    },
    {
      label: t('pb.productdetails.details.product.label'),
      value: serviceModel.productDisplayName ?? '-',
      testId: 'product-detail-product-name',
    },
    {
      label: t('pb.productdetails.details.productLine.label'),
      value: serviceModel?.productLineName ?? '-',
      testId: 'product-detail-product-line',
    },
    {
      label: t('pb.productdetails.details.productImplementation.label'),
      value: serviceModel?.productImplementationName ?? '-',
      testId: 'product-detail-product-implementation',
    },
    {
      label: t('pb.productdetails.details.investmentStrategy.label'),
      value: serviceModel?.investmentStrategyName ?? '-',
      testId: 'product-detail-investment-strategy',
    },
    {
      label: t('pb.productdetails.details.bankingServicePackage.label'),
      value: '-',
      testId: 'product-detail-banking-service-package',
    },
    {
      label: t('pb.productdetails.details.transactionFeeModel.label'),
      value: serviceModel?.transactionFeeModelName ?? '-',
      testId: 'product-detail-transaction-fee',
    },
    {
      label: t('pb.productdetails.details.currency.label'),
      value: serviceModel?.currencyCode ?? '-',
      testId: 'product-detail-currency',
    },
  ];

  return <ProductDetailRows rows={detailItems} />;
};
